export const colors = {
  main: "#502c82",
  accent: "#895acc",
  background: "white",
  backgroundAccent: "#f7f8fa",
  outline: "#e8e8e8",
  backgroundThird: "#ebebeb",
  offBlack: "#5c5c5c",
}